export default "/images/shildikMore.svg?578ce6dc8e37ef29d51389a27ef60d01";